/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  BulkMoveFolderDocumentsResponseData,
  BulkMoveFolderDocumentsResponseDataFromJSON,
  BulkMoveFolderDocumentsResponseDataFromJSONTyped,
  BulkMoveFolderDocumentsResponseDataToJSON
} from './BulkMoveFolderDocumentsResponseData'

/**
 *
 * @export
 * @interface BulkMoveFolderDocumentsResponse
 */
export interface BulkMoveFolderDocumentsResponse {
  /**
   *
   * @type {number}
   * @memberof BulkMoveFolderDocumentsResponse
   */
  status?: number
  /**
   *
   * @type {BulkMoveFolderDocumentsResponseData}
   * @memberof BulkMoveFolderDocumentsResponse
   */
  data?: BulkMoveFolderDocumentsResponseData
}

export function BulkMoveFolderDocumentsResponseFromJSON(json: any): BulkMoveFolderDocumentsResponse {
  return BulkMoveFolderDocumentsResponseFromJSONTyped(json, false)
}

export function BulkMoveFolderDocumentsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BulkMoveFolderDocumentsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : BulkMoveFolderDocumentsResponseDataFromJSON(json['data'])
  }
}

export function BulkMoveFolderDocumentsResponseToJSON(value?: BulkMoveFolderDocumentsResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: BulkMoveFolderDocumentsResponseDataToJSON(value.data)
  }
}
